import { createReducer } from 'redux-act'
import { selector as configSelector } from '~/config'
import { all } from 'redux-saga/effects'

import { Entity } from '~/utils/entity-utils'

import API from '~/api'

const entityName = 'productImageManager';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = entity.actions;

// WORKERS
export const workers = { ...entity.workers };

// SAGA
export function * saga() {
  yield all(entity.saga);
}

export const reducer = createReducer(entity.reducer, {});

export const STATE_ENABLED = 'enabled';
export const STATE_DISABLED = 'disabled';
export const STATE_DELETED = 'deleted';

export const states = {
  STATE_ENABLED,
  STATE_DISABLED,
  STATE_DELETED
};


export default {
  actions,
  workers,
  saga,
  reducer
}